import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaClock, FaBook } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { MdSchool, MdPeople, MdPerson } from "react-icons/md";
import ExamDetails from "../../Class/Individual/ExamDetails";
import Bus_Create_form from "../BusCreation/Bus_Create_form";
import Bus_Table from "../BusCreation/Bus_Table";
import BusTable from "../BusCreation/Bus_Table";
import Route_create from "../BusRoute/Route_create";
import RoutTable from "../BusRoute/Rout_Table";
import Rout_Table from "../BusRoute/Rout_Table";
import Create_Driver from "../Driver/Create_Driver";
// import List_Driver from "../Driver/List_Driver";
import Main_Page_staff from "../Driver/Main_Page_staff";
import Fine_Modal from "../Fine/Fine_Modal";
import FineTable from "../Fine/FineTable";
//   import Print_pdf_classDetails from "./Print_pdf_classDetails";
import StaffList from "../Driver/List_Driver";
const Bus_details = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Bus Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              {/* Add a Button to trigger the  Modal */}
              {/* <Button
              marginRight={2}

                className="export-button"
                // display={{ base: "none", md: "flex" }}
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
                // onClick={handlePrint} 
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button> */}
              {/* Add a Button to trigger the Bus_Create_form Modal */}
              <Grid
                templateColumns={{ base: "1fr 1fr", sm: "repeat(4, 1fr)" }}
                gap={2}
              >
                <Fine_Modal />
                <Route_create />
                <Bus_Create_form /> {/* Embeds the Bus_Create_form component */}
                <Create_Driver />
              </Grid>
            </div>
          </div>
        </div>

        <Box className="breadcrumb" >
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Bus </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Bus Details</span>
          </Link>
        </Box>
      </div>

      <Box p={5} flex="2" mb={9}>
        <Tabs
          variant="soft-rounded"
          colorScheme="teal"
          isFitted
          p={2}
          // boxShadow="lg"
          borderRadius="md"
          bg={useColorModeValue("white", "gray.700")}
        >
          <TabList>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Route
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Bus
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Staff
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                borderRadius: "md",
              }}
              py={2}
            >
              Fine
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={1}>
              <Rout_Table />
            </TabPanel>
            <TabPanel p={1}>
              <BusTable />
            </TabPanel>
            <TabPanel p={1}>
              {/* <Main_Page_staff /> */}

              <StaffList />
            </TabPanel>
            <TabPanel p={1}>
              <FineTable />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default Bus_details;
